// ** React Imports
import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import UICustomizationLayout from 'src/components/ui-customization/UICustomizationLayout'
import ElementsTab from 'src/components/ui-customization/tabs/ElementsTab'
import { CustomizeUIPagesType } from 'src/lib/types/customizeUI'

const ElementsPage: React.FC = () => {
  const router = useRouter()

  useEffect(() => {
    if (router.query.scrollTo !== 'exit-nudge') return
    const el = document.getElementById('exit-nudge')
    if (!el) return
    const timer = setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300)
    return () => clearTimeout(timer)
  }, [router.query.scrollTo])

  return (
    <UICustomizationLayout
      title="Core Setup"
      pageType={'ELEMENTS' as CustomizeUIPagesType}
    >
      <ElementsTab />
    </UICustomizationLayout>
  )
}

export default ElementsPage
